var measurementData;
var numberLocale;

$(document).ready(function () {
    if($('.measurements').length > 0){
        var jsonUrl = $('.measurements').data("jsonurl");
        $.getJSON(jsonUrl + "&t=" + Date.now(), function(data) {
            initMeasurementData(data);
            initLocale();
            //check if IntersectionObserver is supported (for scroll effect)
            if ('IntersectionObserver' in window &&
                'IntersectionObserverEntry' in window &&
                'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
                var observer = new IntersectionObserver(function(entries) {
                    for(let idx=0; idx < entries.length; idx++) {
                        if (entries[idx].isIntersecting === true && !$(entries[idx].target).hasClass("widget-initialized")) {
                            $(entries[idx].target).displayMeasurement();
                        }
                    }
                }, { threshold: [0.3] });
                $(".measurement-widget").each(function () {
                    observer.observe(this);
                });
            } else {
                $(".measurement-widget").each(function(){
                    $(this).displayMeasurement();
                });
            }
            $('.widget-info-text-button, .widget-info-text-click-area').click(function () {
                var $widget = $(this).closest('.measurement-widget');
                var $infoText = $(this).siblings('.widget-info-text').fadeIn();
                $widget.toggleClass("info-text-open");
                if ($widget.hasClass("info-text-open")) {
                    $infoText.fadeIn();
                } else {
                    $infoText.fadeOut();
                }
            });
        }).fail(function() {
            $('.measurements').html("Die Daten konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut.");
        });
    }
});

function initMeasurementData(data) {
    measurementData = {
        windDirection: data.WDIR100,
        windDirectionArrow: 180 + data.WDIR100,
        windSpeed100: data.WSPD100 * 3.6,
        humidity: data.RH100,
        windSpeed150: data.WSPD150 * 3.6,
        windSpeed120: data.WSPD120 * 3.6,
        windSpeed90: data.WSPD90 * 3.6,
        windSpeed60: data.WSPD60 * 3.6,
        // factor 0.83 because the speed at 30m is taken from 60m
        windSpeed30: data.WSPD30 * 0.83 * 3.6,
        windSpeed2: data.WSPD * 3.6,
        windSpeedMax: Math.max(data.WSPD150, data.WSPD120, data.WSPD90, data.WSPD60, data.WSPD30, data.WSPD) * 3.6,
        temperature: data.T100,
        powerOpus1: data.OPUS1_POW_GRID,
        powerOpus2: data.OPUS2_POW_GRID,
        time: data.TIME,
        date: data.DATE
    };
    $('.measurement-time').html(measurementData.time);
    $('.measurement-date').html(measurementData.date);
}

function initLocale() {
    numberLocale = $('.measurements').data("number-locale");
}

function getWindDirectionTitle(direction) {
    if (direction < 23 || direction >= 338) {
        return windDirections[0];
    } else if (direction < 68) {
        return windDirections[0] + "-" + windDirections[1];
    } else if (direction < 113) {
        return windDirections[1];
    } else if (direction < 158) {
        return windDirections[2] + "-" + windDirections[1];
    } else if (direction < 203) {
        return windDirections[2];
    } else if (direction < 248) {
        return windDirections[2] + "-" + windDirections[3];
    } else if (direction < 293) {
        return windDirections[3];
    } else if (direction < 338) {
        return windDirections[0] + "-" + windDirections[3];
    }
}

function calculatePerformanceCurveWidth(speed) {
    if (speed < 12) {
        return (speed * 11 / 12) + 4;
    } else if (speed < 45) {
        return ((speed-12) * 29 / 33) + 15;
    } else if (speed <= 90) {
        return ((speed-45) * 41 / 45) + 44;
    }
    return 90;
}

function calculatePerformanceCurveWidthMobile(speed) {
    if (speed < 12) {
        return (speed * 16 / 12) + 10;
    } else if (speed < 45) {
        return ((speed-12) * 23 / 33) + 26;
    } else if (speed <= 90) {
        return ((speed-45) * 33 / 45) + 49;
    }
    return 90;
}

function calculatePerformance(speed) {
    if (speed < 12 ) {
        return 0;
    } else if (speed < 45) {
        return (speed-12) * 100 / 33;
    } else if (speed <= 90) {
        return 100;
    }
    return 0;
}

function calculateWindSpeedLineWidth(speed) {
    return speed * 100 / measurementData.windSpeedMax;
}

function calculateWindSpeedLineAniDuration(speed) {
    return measurementData.windSpeedMax / speed * 0.5;
}

function calculateTemperatureColorPosition(temperature) {
    if (temperature < 3) {
        return 0;
    } else if (temperature < 30) {
        return (temperature-3) * 100 / 27;
    }
    return 100;
}

function initHumidityParticles(humidity) {
    if($('#humidity-particles').length > 0) {
        particlesJS('humidity-particles', {
            "particles": {
                "number": {
                    "value": 0,
                    "density": {
                        "enable": true,
                        "value_area": 2000
                    }
                },
                "color": {
                    "value": "#AFE0FF"
                },
                "shape": {
                    "type": "circle",
                    "stroke": {
                        "width": 0
                    }
                },
                "opacity": {
                    "value": 1,
                    "random": false,
                    "anim": {
                        "enable": false
                    }
                },
                "size": {
                    "value": 4,
                    "random": false,
                    "anim": {
                        "enable": false
                    }
                },
                "line_linked": {
                    "enable": false
                },
                "move": {
                    "enable": true,
                    "speed": 0.5,
                    "direction": "none",
                    "random": false,
                    "straight": false,
                    "out_mode": "out",
                    "bounce": false,
                    "attract": {
                        "enable": false
                    }
                }
            },
            "interactivity": {
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": false
                    },
                    "onclick": {
                        "enable": false
                    },
                    "resize": true
                }
            },
            "retina_detect": true
        });

        // animate particle number
        $('#humidity-particles').each(function () {
            $(this).prop('Counter',0).animate({
                Counter: Math.pow(Math.round(humidity), 2)
            }, {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                    pJSDom[0].pJS.particles.number.value = Math.ceil(now);
                    pJSDom[0].pJS.fn.vendors.densityAutoParticles();
                }
            });
        });
    }
}

$.fn.displayMeasurement = function() {
    $(this).addClass("widget-initialized");
    var type = $(this).data("widget-type");
    switch (type) {
        case 'wind_direction':
            $(this).find('.wind-direction-title').html(getWindDirectionTitle(measurementData.windDirection));
            $(this).find('.wind-direction-current').html(Math.round(measurementData.windDirection) + "°");
            $(this).find('.wind-direction-arrow').css("transform", "rotate(" + measurementData.windDirectionArrow + "deg)");
            break;
        case 'relative_humidity':
            $(this).find('.humidity-current').html(Math.round(measurementData.humidity));
            initHumidityParticles(measurementData.humidity);
            $(this).find('.humidity-current').animateNumber({unit: "%"});
            break;
        case 'performance_curve':
            const decimals = 1;
            const unit = "&nbsp;MW";
            const formatter = new Intl.NumberFormat(numberLocale, {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals
            });
            const windSpeedMinPerformance = 3.2 * 3.6;
            let wea = $(this).data("widget-wea");
            let windSpeed = measurementData.windSpeed90;
            let power;
            switch (wea) {
                case 'opus1':
                    power = measurementData.powerOpus1;
                    break;
                case 'opus2':
                    power = measurementData.powerOpus2;
            }
            power = Math.round(power / 100) / 10;
            if (power === 0) {
              windSpeed = 0;
            } else if (windSpeed <= windSpeedMinPerformance) {
                power = 0;
            }
            $(this).find('.performance-curve-current').html(formatter.format(power) + unit);
            $(this).find('.performance-curve-current-animated').animateNumber({unit: unit, decimals: decimals, goal: power});
            $(this).find('.performance-curve-width-desktop').css("width", calculatePerformanceCurveWidth(windSpeed) + "%");
            $(this).find('.performance-curve-width-mobile').css("width", calculatePerformanceCurveWidthMobile(windSpeed) + "%");
            if (windSpeed > 90) {
                $(this).find('.performance-curve-green').css("background", "none");
            }
            break;
        case 'wind_speed':
            $(this).find('.wind-speed-current-150').html(Math.round(measurementData.windSpeed150) + " km/h");
            $(this).find('.wind-speed-current-120').html(Math.round(measurementData.windSpeed120) + " km/h");
            $(this).find('.wind-speed-current-90').html(Math.round(measurementData.windSpeed90) + " km/h");
            $(this).find('.wind-speed-current-60').html(Math.round(measurementData.windSpeed60) + " km/h");
            $(this).find('.wind-speed-current-30').html(Math.round(measurementData.windSpeed30) + " km/h");
            $(this).find('.wind-speed-current-2').html(Math.round(measurementData.windSpeed2) + " km/h");
            $(this).find('.wind-speed-line-current-150').css("width", calculateWindSpeedLineWidth(measurementData.windSpeed150) + "%")
                .css("animation-duration", calculateWindSpeedLineAniDuration(measurementData.windSpeed150) + "s");
            $(this).find('.wind-speed-line-current-120').css("width", calculateWindSpeedLineWidth(measurementData.windSpeed120) + "%")
                .css("animation-duration", calculateWindSpeedLineAniDuration(measurementData.windSpeed120) + "s");
            $(this).find('.wind-speed-line-current-90').css("width", calculateWindSpeedLineWidth(measurementData.windSpeed90) + "%")
                .css("animation-duration", calculateWindSpeedLineAniDuration(measurementData.windSpeed90) + "s");
            $(this).find('.wind-speed-line-current-60').css("width", calculateWindSpeedLineWidth(measurementData.windSpeed60) + "%")
                .css("animation-duration", calculateWindSpeedLineAniDuration(measurementData.windSpeed60) + "s");
            $(this).find('.wind-speed-line-current-30').css("width", calculateWindSpeedLineWidth(measurementData.windSpeed30) + "%")
                .css("animation-duration", calculateWindSpeedLineAniDuration(measurementData.windSpeed30) + "s");
            $(this).find('.wind-speed-line-current-2').css("width", calculateWindSpeedLineWidth(measurementData.windSpeed2) + "%")
                .css("animation-duration", calculateWindSpeedLineAniDuration(measurementData.windSpeed2) + "s");
            break;
        case 'temperature':
            $(this).find('.temperature-current').html(Math.round(measurementData.temperature));
            $(this).css("background-position-x", calculateTemperatureColorPosition(measurementData.temperature) + "%");
            $(this).find('.temperature-current').animateNumber({unit: "°"});
    }
}

$.fn.animateNumber = function(options) {
    var settings = $.extend({
        unit: "",
        decimals: 0,
        goal: $(this).text(),
        stepFunction: function(now) {
            let factor = Math.pow(10, settings.decimals);
            $(this).html(formatter.format(Math.ceil(now * factor)/factor) + settings.unit);
        }
    }, options );
    const formatter = new Intl.NumberFormat(numberLocale, {
        minimumFractionDigits: settings.decimals,
        maximumFractionDigits: settings.decimals
    })
    $(this).prop('Counter',0).animate({
        Counter: settings.goal
    }, {
        duration: 1000,
        easing: 'swing',
        step: settings.stepFunction
    });
}